/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MonthlyCoveragePlanStatusDto } from './monthlyCoveragePlanStatusDto.schema';

export const IReadOnlyListOfMonthlyCoveragePlanStatusDto = zod.array(zod.lazy(() => MonthlyCoveragePlanStatusDto));

export type IReadOnlyListOfMonthlyCoveragePlanStatusDto = zod.input<typeof IReadOnlyListOfMonthlyCoveragePlanStatusDto>;
export type IReadOnlyListOfMonthlyCoveragePlanStatusDtoOutput = zod.output<typeof IReadOnlyListOfMonthlyCoveragePlanStatusDto>;
